































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {NestedEditModel, RateRuleSelectListItem, StSelectListItem} from '@/services/api/nswag/stapiclient_generated';
import RateRuleSelect from '@/views/RateRules/RateRuleSelect.vue';
import {ToggleHandler} from '@/utlitities/helper';

@Component({
    components: {
        RateRuleSelect
    },
})
export default class RateRuleProjectSelect extends Vue {
    @Prop()items!: RateRuleSelectListItem[];
    @Prop()value!: Array<NestedEditModel>;

    custToggleHandler: ToggleHandler = new ToggleHandler();

    filterResult(result:Array<NestedEditModel>){
        return result.filter(x=> x.allSelected || x.nestedIds!.length > 0)
    }

    mounted(){
        this.custToggleHandler.toggleMultiple(this.value.map(x=>x.id!));
    }

    allProjectsDisabled(customer: RateRuleSelectListItem){
        return customer.disabledParentNotSelected
            || customer.disabledChildSelected
            || (customer.childItems && customer.childItems!.some(x=>x.disabledParentNotSelected));
    }

    @Emit('input')
    selectProject(customerId: number, projectIds: number[]){
        let result:Array<NestedEditModel> = JSON.parse(JSON.stringify(this.value));

        let customer: NestedEditModel = NestedEditModel.fromJS({id: customerId, allSelected: false, nestedIds: []});

        if(result.some(x=>x.id == customerId)){
            customer = result.find(x=>x.id == customerId)!;
            customer.nestedIds = projectIds.map(x=> {return NestedEditModel.fromJS({id:x})});
        }else{
            customer.nestedIds = projectIds.map(x=> {return NestedEditModel.fromJS({id:x})});
            result.push(customer);
        }

        return this.filterResult(result);
    }

    selectedProjectIds(customerId: number){
        if(!this.value.find(x=>x.id == customerId)){
            return [];
        }

        return this.value.find(x=>x.id == customerId)!.nestedIds!.map(x=>x.id);
    }

    toggleSelectAllProjects(customer : RateRuleSelectListItem){
        const selected = !this.allProjectsSelected(customer.id!);

        let result:Array<NestedEditModel> = JSON.parse(JSON.stringify(this.value));

        let newCustomer: NestedEditModel = NestedEditModel.fromJS({id: customer.id!, nestedIds: []});

        if(result.some(x=>x.id == customer.id!)){
            newCustomer = result.find(x=>x.id == customer.id!)!;
            newCustomer.allSelected = selected;
        }else{
            newCustomer.allSelected = selected;
            result.push(newCustomer);
        }

        return this.$emit('input', this.filterResult(result));
    }

    allProjectsSelected(customerId :number){
        return this.value.some(x=>x.id == customerId && x.allSelected);
    }
}
